import {
  AccessPointProcessingGroup,
  AccessPointProcessingStep,
  ImportConfigurationGroupResponse,
  ImportConfigurationResponse,
} from "../models";

export type ImportConfigActions =
  { type: ImportConfigAction.AddGroupsSuccess, response: ImportConfigurationGroupResponse[] } |
  { type: ImportConfigAction.EditStepHide } |
  { type: ImportConfigAction.EditStepShow, step: AccessPointProcessingStep } |
  { type: ImportConfigAction.LoadConfiguration, networkId: number, versionId?: number } |
  { type: ImportConfigAction.LoadConfigurationSuccess, result: ImportConfigurationResponse } |
  { type: ImportConfigAction.LoadConfigurationFailure, error: string } |
  { type: ImportConfigAction.RemoveGroupSuccess, group: AccessPointProcessingGroup } |
  { type: ImportConfigAction.RemoveGroupFailure, error: string } |
  { type: ImportConfigAction.SetStepEdited, step: AccessPointProcessingStep } |
  { type: ImportConfigAction.ToggleStep, step: AccessPointProcessingStep } |
  { type: ImportConfigAction.ToggleAutoActivate } |
  { type: ImportConfigAction.ToggleAutoComplete } |
  { type: ImportConfigAction.ToggleAutoRun };

export enum ImportConfigAction {
  AddGroupsSuccess = "ADD_GROUPS_SUCCESS",
  EditStepHide = "EDIT_STEP_HIDE",
  EditStepShow = "EDIT_STEP_SHOW",
  LoadConfiguration = "LOAD_CONFIGURATION",
  LoadConfigurationSuccess = "LOAD_CONFIGURATION_SUCCESS",
  LoadConfigurationFailure = "LOAD_CONFIGURATION_FAILURE",
  RemoveGroupSuccess = "REMOVE_GROUP_SUCCESS",
  RemoveGroupFailure = "REMOVE_GROUP_FAILURE",
  SetStepEdited = "SET_STEP_EDITED",
  ToggleStep = "TOGGLE_STEP",
  ToggleAutoActivate = "TOGGLE_AUTO_ACTIVATE",
  ToggleAutoComplete = "TOGGLE_AUTO_COMPLETE",
  ToggleAutoRun = "TOGGLE_AUTO_RUN",
}
